import React, { useEffect } from "react";

// Chart.js is loaded via CDN in the HTML, but in React we should use the npm package
// If Chart.js is not installed, run: npm install chart.js
import Chart from "chart.js/auto";
import HeaderLogo  from "../structure/headerlogo";
import CommonIcon from '../common/customicon';

const RoyaltyCalculator = () => {
  useEffect(() => {
    const ctx = document.getElementById("royaltyChart");
    if (ctx) {
      new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["Aurora Animation", "Midnight Echo", "StarBlaze Heroes"],
          datasets: [
            {
              data: [466000, 134250, 210600],
              backgroundColor: ["#3B82F6", "#8B5CF6", "#F97316"],
            },
          ],
        },
        options: {
          responsive: true,
          plugins: { legend: { display: false } },
        },
      });
    }
  }, []);

  return (
    <div className="main-content" style={{ paddingTop: 64 }}>
       <HeaderLogo />
      <div className="page-content">
        <div className="container-fluid">
          <div id="table_height">
    <div className="">
      <div className="flex items-center justify-between mb-6">
        <div className="d-flex align-items-center mb-2">
              <div className="bg-primary text-white rounded p-2 me-3">
                <CommonIcon iconName="Calculator" size={"24px"}  color="#fff" />
              </div>
              <div className="flex-grow-1">
                <h1 className="h3 mb-0 fw-bold">Royalty Calculator</h1>
                <p className="text-muted mb-0 small">Auto-calculate royalty payments based on contract terms</p>
              </div>
              </div>
        <div className="flex gap-2">
          <select className="border rounded-lg px-4 py-2 bg-white">
            <option>Q1 2026</option>
            <option>Q4 2025</option>
            <option>Q3 2025</option>
          </select>
          <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
            Export Report
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-4 gap-2 mb-6">
        <div className="bg-white rounded-xl shadow p-2 border-l-4 border-blue-500">
          <p className="text-sm text-gray-500">Total Royalties Due</p>
          <p className="text-2xl font-bold text-gray-900">$847,250</p>
          <p className="text-sm text-green-600 mt-1">+12.3% vs last quarter</p>
        </div>
        <div className="bg-white rounded-xl shadow p-2 border-l-4 border-green-500">
          <p className="text-sm text-gray-500">Minimum Guarantees Met</p>
          <p className="text-2xl font-bold text-gray-900">14 / 18</p>
          <p className="text-sm text-red-500 mt-1">4 contracts below minimum</p>
        </div>
        <div className="bg-white rounded-xl shadow p-2 border-l-4 border-purple-500">
          <p className="text-sm text-gray-500">Average Royalty Rate</p>
          <p className="text-2xl font-bold text-gray-900">8.2%</p>
          <p className="text-sm text-gray-400 mt-1">Across all active licenses</p>
        </div>
        <div className="bg-white rounded-xl shadow p-2 border-l-4 border-orange-500">
          <p className="text-sm text-gray-500">Underpayment Alerts</p>
          <p className="text-2xl font-bold text-red-600">3</p>
          <p className="text-sm text-red-500 mt-1">Requires immediate review</p>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-6 mb-6">
        {/* Calculator Table */}
        <div className="col-span-2 bg-white rounded-xl shadow p-6">
          <h5 className="text-lg font-semibold mb-4">Contract Royalty Breakdown</h5>
          <div className="overflow-x-auto">
            <table className="w-full min-w-[700px] text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="p-3 text-left">Licensee</th>
                <th className="p-3 text-left">Brand/IP</th>
                <th className="p-3 text-right">Net Sales</th>
                <th className="p-3 text-right">Rate</th>
                <th className="p-3 text-right">Royalty Due</th>
                <th className="p-3 text-right">Min Guarantee</th>
                <th className="p-3 text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t">
                <td className="p-3 font-medium">Summit Ridge Merch</td>
                <td className="p-3">Aurora Animation</td>
                <td className="p-3 text-right">$2,850,000</td>
                <td className="p-3 text-right">8%</td>
                <td className="p-3 text-right font-semibold">$228,000</td>
                <td className="p-3 text-right">$30,000</td>
                <td className="p-3 text-center">
                  <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs">Met</span>
                </td>
              </tr>
              <tr className="border-t">
                <td className="p-3 font-medium">Horizon Peak Retail</td>
                <td className="p-3">Midnight Echo</td>
                <td className="p-3 text-right">$1,200,000</td>
                <td className="p-3 text-right">10%</td>
                <td className="p-3 text-right font-semibold">$120,000</td>
                <td className="p-3 text-right">$50,000</td>
                <td className="p-3 text-center">
                  <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs">Met</span>
                </td>
              </tr>
              <tr className="border-t bg-red-50">
                <td className="p-3 font-medium">Pacific Coast Toys</td>
                <td className="p-3">StarBlaze Heroes</td>
                <td className="p-3 text-right">$180,000</td>
                <td className="p-3 text-right">12%</td>
                <td className="p-3 text-right font-semibold">$21,600</td>
                <td className="p-3 text-right text-red-600 font-semibold">$45,000</td>
                <td className="p-3 text-center">
                  <span className="bg-red-100 text-red-700 px-2 py-1 rounded-full text-xs">Below Min</span>
                </td>
              </tr>
              <tr className="border-t">
                <td className="p-3 font-medium">Golden State Apparel</td>
                <td className="p-3">Aurora Animation</td>
                <td className="p-3 text-right">$3,400,000</td>
                <td className="p-3 text-right">7%</td>
                <td className="p-3 text-right font-semibold">$238,000</td>
                <td className="p-3 text-right">$100,000</td>
                <td className="p-3 text-center">
                  <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs">Met</span>
                </td>
              </tr>
              <tr className="border-t bg-red-50">
                <td className="p-3 font-medium">NovaTech Games</td>
                <td className="p-3">Midnight Echo</td>
                <td className="p-3 text-right">$95,000</td>
                <td className="p-3 text-right">15%</td>
                <td className="p-3 text-right font-semibold">$14,250</td>
                <td className="p-3 text-right text-red-600 font-semibold">$25,000</td>
                <td className="p-3 text-center">
                  <span className="bg-red-100 text-red-700 px-2 py-1 rounded-full text-xs">Below Min</span>
                </td>
              </tr>
              <tr className="border-t">
                <td className="p-3 font-medium">Dreamlight Studios</td>
                <td className="p-3">StarBlaze Heroes</td>
                <td className="p-3 text-right">$2,100,000</td>
                <td className="p-3 text-right">9%</td>
                <td className="p-3 text-right font-semibold">$189,000</td>
                <td className="p-3 text-right">$75,000</td>
                <td className="p-3 text-center">
                  <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs">Met</span>
                </td>
              </tr>
            </tbody>
            <tfoot className="bg-gray-50 font-semibold">
              <tr className="border-t-2">
                <td className="p-3" colSpan={2}>Total</td>
                <td className="p-3 text-right">$9,825,000</td>
                <td className="p-3"></td>
                <td className="p-3 text-right">$810,850</td>
                <td className="p-3"></td>
                <td className="p-3"></td>
              </tr>
            </tfoot>
            </table>
          </div>
        </div>

        {/* Chart */}
        <div className="bg-white rounded-xl shadow p-6">
          <h5 className="text-lg font-semibold mb-4">Royalty by Brand</h5>
          <canvas id="royaltyChart" height="250"></canvas>
          <div className="mt-4 space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-blue-600">Aurora Animation</span>
              <span className="font-semibold">$466,000</span>
            </div>
            <div className="flex justify-between">
              <span className="text-purple-600">Midnight Echo</span>
              <span className="font-semibold">$134,250</span>
            </div>
            <div className="flex justify-between">
              <span className="text-orange-600">StarBlaze Heroes</span>
              <span className="font-semibold">$210,600</span>
            </div>
          </div>
        </div>
      </div>

      {/* Tiered Royalty Example */}
      <div className="bg-white rounded-xl shadow p-6">
        <h5 className="text-lg font-semibold mb-4">
          Tiered Royalty Calculation — Summit Ridge Merch (Aurora Animation)
        </h5>
        <div className="grid grid-cols-4 gap-4">
          <div className="border rounded-lg p-4 bg-blue-50">
            <p className="text-sm text-gray-500">Tier 1: $0 - $1M</p>
            <p className="text-lg font-bold">8% = $80,000</p>
            <div className="w-full bg-blue-200 rounded-full h-2 mt-2">
              <div className="bg-blue-600 h-2 rounded-full" style={{ width: "100%" }}></div>
            </div>
          </div>
          <div className="border rounded-lg p-4 bg-blue-50">
            <p className="text-sm text-gray-500">Tier 2: $1M - $2M</p>
            <p className="text-lg font-bold">6% = $60,000</p>
            <div className="w-full bg-blue-200 rounded-full h-2 mt-2">
              <div className="bg-blue-600 h-2 rounded-full" style={{ width: "100%" }}></div>
            </div>
          </div>
          <div className="border rounded-lg p-4 bg-blue-50">
            <p className="text-sm text-gray-500">Tier 3: $2M - $3M</p>
            <p className="text-lg font-bold">5% = $42,500</p>
            <div className="w-full bg-blue-200 rounded-full h-2 mt-2">
              <div className="bg-blue-600 h-2 rounded-full" style={{ width: "85%" }}></div>
            </div>
          </div>
          <div className="border rounded-lg p-4 bg-green-50">
            <p className="text-sm text-gray-500">Total Blended</p>
            <p className="text-2xl font-bold text-green-700">$182,500</p>
            <p className="text-sm text-gray-500 mt-1">Effective rate: 6.4%</p>
          </div>
        </div>
      </div>
    </div></div></div></div></div>
  );
};

export default RoyaltyCalculator;
